import { PlusIcon } from './PlusIcon'
import styled from 'styled-components'

export const CrossIcon = styled(PlusIcon)`
  transform: rotate(45deg);
`
